module.exports = __webpack_public_path__ + "img/jbb-logo.4341162e.png";